if (!com) var com = {};

if (!com.openlane) com.openlane = {};

if (!com.openlane.auction) com.openlane.auction = {};

if(!com.nw) com.nw = {};

com.nw.classicUser = {
    loginName: 'guest'
};
function setClassicUser(classicUser) {
    com.nw.classicUser = classicUser;
}



// WEBPACK FOOTER //
// node_modules/@nw/ui-core-shared/utilities/classic.js